__turbopack_context__.v({
  "container": "styles-module__TG4VWa__container",
  "text": "styles-module__TG4VWa__text",
});
